var map = {
	"./Img3.jpg": 244,
	"./bankistApp.jpg": 42,
	"./calculator.jpg": 744,
	"./countryInfo.jpg": 272,
	"./digitalClock.jpg": 558,
	"./guessingGame.jpg": 758,
	"./kunal profile pic.jpg": 649,
	"./kunal profile pic2.jpg": 420,
	"./movieApp.jpg": 257,
	"./mypic3.jpg": 852,
	"./myportfolio1.jpg": 705,
	"./myportfolio2.jpg": 361,
	"./myportfolio3.jpg": 198,
	"./myportfolio4.jpg": 842,
	"./quiz.jpg": 637,
	"./quiz2.jpg": 83,
	"./scorekeeper.jpg": 923,
	"./tictactoe.jpg": 725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 456;